import { BrowserRouter, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import ProfilePage from "./pages/ProfilePage";
import DemoPage from "./pages/DemoPage";
import BookingPage, { BeautyBookingDemo } from "./pages/BookingPage";
import MyTicketsPage from "./pages/MyTicketsPage";
import OrganizationPublicPage from "./pages/OrganizationPublicPage";
import SalonBookingPage from "./pages/SalonBookingPage";
import MasterLayout from "./layout/MasterLayout";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ScrollToTop from "react-scroll-to-top";
import useModals from "./helper/useModals";
import { LocaleWrapper } from "./locales/localeWrapper";

// A small component just to handle redirect on root "/"
function LanguageRedirect() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/") {
      navigate(`/${i18n.language}`, { replace: true });
    }
  }, [pathname, i18n.language, navigate]);

  return null;
}

function App() {
  const modals = useModals();

  return (
    <BrowserRouter>
      {/* <LanguageRedirect /> */}
      <RouteScrollToTop />
      <ScrollToTop color="hsl(166, 100%, 41%)" />
      <LocaleWrapper>


      <Routes>
        <Route path="/" element={<MasterLayout {...modals} />}>
          <Route index element={<HomePage {...modals} />} />
          <Route path="blog" element={<BlogPage {...modals} />} />
          <Route path="blog/:slug" element={<BlogDetailsPage />} />
          <Route path="contact" element={<ContactPage {...modals} />} />
          <Route path="profile" element={<ProfilePage {...modals} />} />
          <Route path="demo" element={<DemoPage {...modals} />} />
          <Route path="online-booking" element={<BookingPage {...modals} />} />
          <Route path="online-booking/beauty-demo" element={<BeautyBookingDemo {...modals} />} />
          <Route path="online-booking/tickets" element={<MyTicketsPage {...modals} />} />
          <Route path="online-booking/org/:bookingOrg" element={<OrganizationPublicPage {...modals} />} />
          <Route path="online-booking/industry/:bookingIndustry" element={<BookingPage {...modals} />} />
          <Route path="online-booking/:bookingOrg" element={<BookingPage {...modals} />} />
          <Route path="online-booking/:bookingOrg/:bookingBranch" element={<BookingPage {...modals} />} />
          <Route path="book" element={<SalonBookingPage {...modals} />} />
          <Route path="book/:salonSlug" element={<SalonBookingPage {...modals} />} />
          <Route path=":lang">
            <Route index element={<HomePage {...modals} />} />
            <Route path="blog" element={<BlogPage {...modals} />} />
            <Route path="blog/:slug" element={<BlogDetailsPage />} />
            <Route path="contact" element={<ContactPage {...modals} />} />
            <Route path="profile" element={<ProfilePage {...modals} />} />
            <Route path="demo" element={<DemoPage {...modals} />} />
            <Route path="online-booking" element={<BookingPage {...modals} />} />
            <Route path="online-booking/beauty-demo" element={<BeautyBookingDemo {...modals} />} />
            <Route path="online-booking/tickets" element={<MyTicketsPage {...modals} />} />
            <Route path="online-booking/org/:bookingOrg" element={<OrganizationPublicPage {...modals} />} />
            <Route path="online-booking/industry/:bookingIndustry" element={<BookingPage {...modals} />} />
            <Route path="online-booking/:bookingOrg" element={<BookingPage {...modals} />} />
            <Route path="online-booking/:bookingOrg/:bookingBranch" element={<BookingPage {...modals} />} />
            <Route path="book" element={<SalonBookingPage {...modals} />} />
            <Route path="book/:salonSlug" element={<SalonBookingPage {...modals} />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </LocaleWrapper>
    </BrowserRouter>
  );
}

export default App;
